import { api } from "./api";

const challanApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getChallans: builder.query({
      query: () => "/challan",
      providesTags: ["challan"],
    }),
    addChallans: builder.mutation({
      query: (newData) => ({
        url: "/challan",
        method: "POST",
        body: newData,
      }),
      invalidatesTags: ["challan"],
    }),
    removeChallan: builder.mutation({
      query: (id) => ({
        // url: `orders2/${id}`,
        url: `/challans?ch_no=${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["challan"],
    }),
    editChallan: builder.mutation({
      query: ({id,...editData}) => ({
        url: `/challan/${id}`,
        method: "PATCH",
        body: editData,
      }),
      invalidatesTags: ["challan"],
    }),
  }),
});

export const {
  useGetChallansQuery,
  useAddChallansMutation,
  useRemoveChallanMutation,
  useEditChallanMutation,
} = challanApi;
